import { produce } from "immer";
import { Store } from "reducers/rootReducer";


/* STATE */
type State = {
  open: boolean; 
}

const initialState: State = {
  open: false,
}    

/* ACTIONS */
const OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";
const CLOSE_MOBILE_MENU = "CLOSE_MOBILE_MENU";

type Action =
| { type: typeof OPEN_MOBILE_MENU }
| { type: typeof CLOSE_MOBILE_MENU }

/* REDUCER */
export default function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case OPEN_MOBILE_MENU:      
        draft.open = true;
        break;
      case CLOSE_MOBILE_MENU:      
        draft.open = false;
        break;
    }
  })
}

/* ACTION CREATORS */
export const openMobileMenu = (): Action => ({
  type: OPEN_MOBILE_MENU,
});

export const closeMobileMenu = (): Action => ({
  type: CLOSE_MOBILE_MENU,
});

/* SELECTORS */
export const selectMobileMenuOpen = (app: Store) => app.mobileMenu.open;